module.exports = __webpack_public_path__ + "img/donante-aimo.1ca99b89.jpeg";